export default "__VITE_ASSET__Bku4kqSv__"